module.exports = __webpack_public_path__ + "img/image12@2x.f452788e.png";